module.exports = __webpack_public_path__ + "img/mostlysunny.b19a6f73.png";